/* tslint:disable */
/* eslint-disable */
/* @relayHash d956f1247d336dbf373762f0ef15addf */

import { ConcreteRequest } from "relay-runtime";
export type UserType = "delegate" | "individual" | "manager" | "%future added value";
export type RecoverPassword_ResetRequestMutationVariables = {
    email: string;
    role: UserType;
};
export type RecoverPassword_ResetRequestMutationResponse = {
    readonly resetPasswordRequest: boolean;
};
export type RecoverPassword_ResetRequestMutation = {
    readonly response: RecoverPassword_ResetRequestMutationResponse;
    readonly variables: RecoverPassword_ResetRequestMutationVariables;
};



/*
mutation RecoverPassword_ResetRequestMutation(
  $email: String!
  $role: UserType!
) {
  resetPasswordRequest(input: {email: $email, role: $role})
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "email",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "role",
            "type": "UserType!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "resetPasswordRequest",
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "email",
                            "variableName": "email"
                        },
                        {
                            "kind": "Variable",
                            "name": "role",
                            "variableName": "role"
                        }
                    ]
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RecoverPassword_ResetRequestMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RecoverPassword_ResetRequestMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RecoverPassword_ResetRequestMutation",
            "id": null,
            "text": "mutation RecoverPassword_ResetRequestMutation(\n  $email: String!\n  $role: UserType!\n) {\n  resetPasswordRequest(input: {email: $email, role: $role})\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '1ed300be685c7cb407daf3089d264e61';
export default node;
